import * as React from 'react'

import {
  tripLoginModalSignUpDismiss,
  tripLoginModalSignUpView,
} from 'analytics/eventDefinitions'
import { fireInteractionEvent } from 'api/googleTagManager'
import WishlistOfferBookmarkButton from 'wishlists/components/WishlistOfferBookmarkButton'
import { useCruiseWishlistDisplayFields } from 'wishlists/hooks/useWishlistDisplayFields'

interface Props {
  offer: App.CruiseOffer
  withLabel?: React.ComponentProps<typeof WishlistOfferBookmarkButton>['withLabel']
}

const trackTripLoginModalSignUpView = () => {
  fireInteractionEvent(tripLoginModalSignUpView('save'))
}
const trackTripLoginModalSignUpDismiss = () => {
  fireInteractionEvent(tripLoginModalSignUpDismiss('save'))
}

function CruiseBookmarkButton({ offer, withLabel }: Props) {
  const wishlistDisplayFields = useCruiseWishlistDisplayFields(offer)

  return (
    <WishlistOfferBookmarkButton
      item={{
        type: 'cruise_v2',
        code: offer.id,
      }}
      {...wishlistDisplayFields}
      withLabel={withLabel}
      onShowLogin={trackTripLoginModalSignUpView}
      onDismissLogin={trackTripLoginModalSignUpDismiss}
    />
  )
}

export default CruiseBookmarkButton
